import React, { useState } from 'react';
import { showManageInvitationsModal } from 'actions/modal';
import { displayGlobalMessage } from 'actions/globalMessage';
import { cancelInvitationByUserId, getUserInvitationsByUserId, updateSingleUsersForAdmin } from 'actions/user';

const RightPanelConfirmation = (props) => {
  const [isSavingChanges, setIsSavingChanges] = useState(false);

  let deleteAllRolesICanSee = false;
  if (
    props.intendedDeletedInvitatioans &&
    props.selectedUserInvitationForm &&
    props.selectedUserInvitationForm.roles.length == props.intendedDeletedInvitatioans.length
  ) {
    deleteAllRolesICanSee = true;
  }

  const confirmDeletion = () => {
    if (isSavingChanges) return;
    setIsSavingChanges(true);
    let deletedPersonNetworkRoleId = [];
    props.intendedDeletedInvitatioans.map((role) => {
      deletedPersonNetworkRoleId.push(role.personNetworkRoleId);
    });
    let cb = (successful) => {
      setIsSavingChanges(false);
      if (successful) {
        if (!!deleteAllRolesICanSee) {
          // If deleting all roles I can see
          // Remove the row in user listing page then close the dialog
          props.dispatch(updateSingleUsersForAdmin(props.selectedUser.personId));
          props.dispatch(showManageInvitationsModal(false));
        } else {
          // Otherwise go back to previous page
          props.dispatch(getUserInvitationsByUserId(props.selectedUser.personId, props.goBackToPreviousView));
        }

        props.dispatch(
          displayGlobalMessage({
            text: APP.LANGUAGE.ManageInvitations.RolesRemovedSuccessfulMessage.replace(
              '##invitedUserEmailAddress##',
              props.selectedUser.email
            ),
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
      }
    };
    props.dispatch(cancelInvitationByUserId(props.selectedUser.personId, deletedPersonNetworkRoleId, cb));
  };

  let deleteAllRoles = false;
  let deleteRolesText =
    props.intendedDeletedInvitatioans && props.intendedDeletedInvitatioans.length == 1
      ? APP.LANGUAGE.ManageInvitations.RemoveRoleConfirm.replace('##thisRole##', 'this role')
      : APP.LANGUAGE.ManageInvitations.RemoveRoleConfirm.replace('##thisRole##', 'these roles');
  let deleteClass = 'mrtm';
  let deleteRolesExtraText = '';
  let hasRolesInOtherNetworks = false;
  if (props.selectedUserInvitationForm && props.selectedUserInvitationForm.hasRolesInOtherNetworks === true) {
    hasRolesInOtherNetworks = true;
  }

  if (deleteAllRolesICanSee && !hasRolesInOtherNetworks) {
    deleteAllRoles = true;
    deleteRolesText = APP.LANGUAGE.ManageInvitations.RemoveRoleConfirm.replace('##thisRole##', 'all roles');
    deleteRolesExtraText = APP.LANGUAGE.ManageInvitations.RemoveAllRoleConfirm;
    deleteClass = 'mrtxs';
  }

  let saveClasses =
    'ui  labeled icon button icon left-text color-button color-button-hover color-white max-width mrbm mrlnull mrbnull';

  let cancelClasses =
    'ui  labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width mrlnull mrbnull';
  return (
    <div>
      <div className="mrbm title-sms">{deleteRolesText}</div>
      {deleteAllRoles ? <div className="mrbm title-sms">{deleteRolesExtraText}</div> : ''}

      <div className="mrtxxs mrbl max-width">
        <button
          type="button"
          onClick={confirmDeletion}
          className={isSavingChanges ? 'loading disabled ' + saveClasses : saveClasses}
        >
          {APP.LANGUAGE.Yes}
          <i className="check icon" />
        </button>
        <button type="button" onClick={props.cancelConfirmUpdate} className={cancelClasses}>
          <i className="remove icon" />
          {APP.LANGUAGE.No}
        </button>
      </div>
    </div>
  );
};
export default RightPanelConfirmation;
